import PermissionButton from '../../permissions/PermissionButton';
import React, { useState } from 'react';
import { Form, Input, Button, Checkbox, Row, Col, Card, Select, Divider, Space, Typography, message } from 'antd';
import { useCreateFour } from '../../hooks/fourHooks';
import { useCountries } from '../../hooks/listsHooks';
import { HomeOutlined, FlagOutlined, IdcardOutlined, FileTextOutlined } from '@ant-design/icons';

const { Option } = Select;
const { Paragraph } = Typography;

const FourForm = ({ onSuccess }) => {
  const [form] = Form.useForm();
  const { handleCreate } = useCreateFour();
  const { countries } = useCountries();
  const [submitting, setSubmitting] = useState(false);

  const handleSubmit = async (values) => {
    setSubmitting(true);
    try {
      await handleCreate(values);
      message.success('Fournisseur ajouté');
      form.resetFields();
      onSuccess?.();
    } catch (error) {
      message.error(error?.response?.data?.message || error?.message || 'Erreur lors de la création du fournisseur');
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <Card title="Ajouter un fournisseur" bordered={false} style={{ width: '100%' }}>
      <Paragraph type="secondary" style={{ marginBottom: 16 }}>
        Centralisez les informations principales pour faciliter la sélection des fournisseurs dans les achats et le stock.
      </Paragraph>
      <Form form={form} layout="vertical" onFinish={handleSubmit} requiredMark={false}>
        <Divider orientation="left">Identité</Divider>
        <Row gutter={16}>
          <Col span={12}>
            <Form.Item
              label="code_frs"
              name="code_frs"
              rules={[{ required: true, message: 'code_frs requis' }]}
            >
              <Input placeholder="code_frs" prefix={<IdcardOutlined />} autoComplete="off" />
            </Form.Item>
            <Form.Item
              label="compte"
              name="compte"
              rules={[{ required: true, message: 'compte requis' }]}
            >
              <Input placeholder="compte" prefix={<HomeOutlined />} autoComplete="off" />
            </Form.Item>
            <Form.Item
              label="sociale"
              name="sociale"
              rules={[{ required: true, message: 'sociale requis' }]}
            >
              <Input placeholder="sociale" prefix={<FileTextOutlined />} autoComplete="off" />
            </Form.Item>
            <Form.Item
              label="pays"
              name="pays"
              rules={[{ required: true, message: 'pays requis' }]}
            >
              <Select
                showSearch
                placeholder="pays"
                optionFilterProp="children"
                suffixIcon={<FlagOutlined />}
                filterOption={(input, option) =>
                  option?.children?.toLowerCase().includes(input.toLowerCase())
                }
              >
                {countries.map(country => (
                  <Option key={country} value={country}>{country}</Option>
                ))}
              </Select>
            </Form.Item>
          </Col>
          <Col span={12}>
            <Divider orientation="left">Options</Divider>
            <Form.Item
              label="echeance"
              name="echeance"
              valuePropName="checked"
            >
              <Checkbox>echeance</Checkbox>
            </Form.Item>
            <Form.Item
              label="cond_paie"
              name="cond_paie"
              valuePropName="checked"
            >
              <Checkbox>cond_paie</Checkbox>
            </Form.Item>
            <Form.Item
              label="bloquer"
              name="bloquer"
              valuePropName="checked"
            >
              <Checkbox>bloquer</Checkbox>
            </Form.Item>
            <Form.Item
              label="note"
              name="note"
            >
              <Input.TextArea rows={4} placeholder="note" showCount maxLength={300} />
            </Form.Item>
          </Col>
        </Row>
        <Divider />
        <Space style={{ width: '100%', justifyContent: 'flex-end' }}>
          <Button onClick={() => form.resetFields()} disabled={submitting}>
            Effacer
          </Button>
          <PermissionButton permissionModule="suppliers" permissionAction="create" type="primary" htmlType="submit" loading={submitting}>
            Enregistrer le fournisseur
          </PermissionButton>
        </Space>
      </Form>
    </Card>
  );
};

export default FourForm;
